import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { Globals } from '../../services/tools/Globals.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material';
/*App imports*/
import { CreditosService } from "../../services/creditos.service";
import { HelpersService, TiposCreditos, EstatusCreditos } from '../../services/tools/helpers.service';
import { SucursalesService } from "../../services/sucursales.service";
import { EditarConvenioCreditComponent } from '../../components/tools/modals/editar-convenio-credit/editar-convenio-credit.component';


@Component({
  selector: 'app-listado-creditos',
  templateUrl: './listado-creditos.component.html',
  providers: [NgbDropdownConfig]
})

export class ListadoCreditosComponent implements OnInit {

  errors:any = {};
  //UI vars
  public listCreditos: any [] = [];
  public tiposCreditos: any = [];
  public sucursales: any[] = [];
  public isLoading: boolean = false;
  //Filters 
  public searchText: string = '';
  public selectedStatus: number = EstatusCreditos.Vigente; //Por default muestra los créditos vigentes
  public tipoCredito: any = null;
  public sucursal: any = null;
  //Pagination vars
  public page: number = 1;
  public pageSize: number = 0;
  public pageAll: number = 0;
  public paginationInfo = { from : null, to : null, total : null };
  //Datepicker
  public fechaInicio: any = null;
  public sucursalPorDefecto: string = "";

  constructor(
    private globals: Globals, 
    private route: ActivatedRoute,
    private router: Router,
    private creditosService: CreditosService,
    private helperService: HelpersService,
    private sucursalesService: SucursalesService,
    private dialog: MatDialog
    ){
   }

  ngOnInit() {
    this.getTiposCreditos();
    this.getSucursales();   
  }

  public selectCredito(credito : any){
    let creditoUrl = '';
    switch(credito.idTipos_Creditos){
      case TiposCreditos.Hipotecario:
        creditoUrl = '/creditos/hipotecario/detalles/';
        break;
      case TiposCreditos.Automotriz:
        creditoUrl = '/creditos/automotriz/detalles/';
        break;
      case TiposCreditos.Prendario:
        creditoUrl = '/creditos/prendario/detalles/';
        break;
      case TiposCreditos.Verde:
        creditoUrl = '/creditos/verde/detalles/';
        break;
      case TiposCreditos.Personal:
        creditoUrl = '/creditos/personal/detalles/';
        break;
      case TiposCreditos.Nomina:
        creditoUrl = '/creditos/nomina/detalles/';
        break;
      case TiposCreditos.Carburacion:
        creditoUrl = '/creditos/carburacion/detalles/';
        break;
      case TiposCreditos.Estacionario:
        creditoUrl = '/creditos/estacionario/detalles/';
        break;
      case TiposCreditos.MesesSinIntereses:
        creditoUrl = '/creditos/comercializacion/detalles/';
        break;
      case TiposCreditos.PlusPension:
        creditoUrl = '/creditos/estacionario/detalles/';
      break;
    }
    this.router.navigate([creditoUrl, credito.id]);
  }

  private getCreditos(){
    let filters = this.getActiveFilters();
    console.log(filters)
    this.isLoading = true;

    this.creditosService.getAll(filters).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        this.isLoading = false;
        
        if(jsonResult.content && jsonResult.content.data){
          const jsonContent = response.json().content;
          this.listCreditos = this.setupCreditLabels(jsonContent.data);
          this.page = jsonContent.current_page;
          this.pageSize = jsonContent.per_page;
          this.pageAll = jsonContent.total;
          this.paginationInfo.from = jsonContent.from;
          this.paginationInfo.to = jsonContent.to;
          this.paginationInfo.total = jsonContent.total;
        }

      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        this.isLoading = false;
        
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getActiveFilters(){
    let filters = {
      page : null,
      search : null,
      status : null,
      tipoCredito : null,
      sucursal : null,
      fechaInicio : null
    };

    if(this.page){
      filters.page = this.page;
    }

    if(this.searchText){
      filters.search = this.searchText;
    }

    if(this.selectedStatus){
      filters.status = this.selectedStatus;
    }

    if(this.tipoCredito){
      filters.tipoCredito = this.tipoCredito.id;
    }

    if(this.sucursal){
      filters.sucursal = this.sucursal.id;
    }

    if(this.fechaInicio){
      filters.fechaInicio = this.fechaInicio;
    }

    return filters;
  }

  private setupCreditLabels(listCreditos){
    listCreditos.forEach(function(credito) {
      switch(credito.statusCredito){
        case EstatusCreditos.Pendiente:
          credito.statusLabel = 'Pendiente';
          break;
        case EstatusCreditos.Vigente:
          credito.statusLabel = 'Vigentes';
          break;
        case EstatusCreditos.Finalizado:
          credito.statusLabel = 'Finalizado';
          break;
      }
    });
    return listCreditos;
  }

  /**
   * Populate catalogs
   */
  private getTiposCreditos(){
    this.creditosService.getTiposCreditos().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.tiposCreditos = jsonResult.content;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.isLoading = false;
          this.getCreditos(); 
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }


  /**
   * Filters methods
   */
  searchKeyword(){
    //El keyword ingresado se obtiene directamente del modelo asociado
    this.getCreditos();
  }

  statusChanged(selectedStatus : number){
    this.selectedStatus = selectedStatus;
    this.getCreditos();
  }

  tipoCreditoChanged(tipoCredito){
    if(tipoCredito){
      this.tipoCredito = tipoCredito;
      this.getCreditos();
    }
  }

  fechaInicioChanged(event){
    this.fechaInicio = event;
    this.getCreditos();
  }

  sucursalChanged(sucursal){
    if(sucursal){
      this.sucursal = sucursal;
      this.getCreditos();
    }
  }

  /**
   * Pagination methods
   */
  public pageChanged(event: any): void {
    if(event)
    {  
      this.getCreditos();
    }
  }

  open_link_convenio(credit_id, convenio_id){
    const dialogRef = this.dialog.open(EditarConvenioCreditComponent, {
      height: 'auto',
      width: 'auto',
      data: { id:credit_id, convenio_id: convenio_id}
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   if(result.eliminar){
    //     window.location.reload();
    //   }
    // });

  }
  
}



// WEBPACK FOOTER //
// ./src/app/creditos/listado/listado-creditos.component.ts